interface BoardMember {
  imagePath: string;
  linkedinPath: string;
  name: string;
  title: string;
  shortDescription: string;
}

const boardMembers: BoardMember[] = [
  {
    imagePath: '/img/01_Ignacio_Fonts.jpg',
    linkedinPath: 'https://www.linkedin.com/in/ignaciofonts/',
    name: 'Ignacio Fonts',
    title: 'Consejero Delegado',
    shortDescription: 'Inveready Asset Management',
  },
  {
    imagePath: '/img/02_JosepMaria_Echarri.jpg',
    linkedinPath: 'https://www.linkedin.com/in/josep-ma-echarri-344b5/',
    name: 'Josep Maria Echarri',
    title: 'CEO de Inveready',
    shortDescription: 'Technology Investment Group',
  },
  {
    imagePath: '/img/03_Angel_Cano.jpg',
    linkedinPath: 'https://www.linkedin.com/in/angel-cano-fern%C3%A1ndez-73a93a143/',
    name: 'Ángel Cano',
    title: 'Ex-CEO del BBVA',
    shortDescription: 'Socio de Sevenzonic Ventures',
  },
  {
    imagePath: '/img/04_Manuel_Galatas.jpg',
    linkedinPath: 'https://www.linkedin.com/in/manuel-galatas-4b3b74b4/',
    name: 'Manuel Galatas',
    title: 'Ex-Director General del BBVA Asia',
    shortDescription: 'Socio de Sevenzonic Ventures',
  },
  {
    imagePath: '/img/05_Marti_Escursell.jpg',
    linkedinPath: 'https://www.linkedin.com/in/martiescursell/',
    name: 'Juan Teijerio',
    title: 'Managing Partner',
    shortDescription: 'Bonsai Venture Capital y Cube Ventures',
  },
  {
    imagePath: '/img/06_Juan_Teijeiro.jpg',
    linkedinPath: 'https://www.linkedin.com/in/juanteijeiro/',
    name: 'Marti Escursell',
    title: 'Managing Partner',
    shortDescription: 'Bonsai Venture Capital y Cube Ventures',
  },
];

export default boardMembers;



// WEBPACK FOOTER //
// ./src/modules/our-team/boardMembers.tsx